import { ReceiveBatchToResolve } from 'src/features/swap-or-return/SwapOrReturnTypes'
import * as S from './ReceiveBatchTable.styles'
import { formatDateReplaceHour } from 'src/utils/formatDate'
import { DeleteOutline } from '@mui/icons-material'
import IconButton from '@mui/material/IconButton'
import { Typography } from '@mui/material'

interface ReceiveBatchTableProps {
  measureUnit: string
  batches: ReceiveBatchToResolve[]
  removeBatch: (index: number) => void
  disableActions: boolean
}

export const ReceiveBatchTable = ({
  measureUnit,
  batches,
  removeBatch,
  disableActions,
}: ReceiveBatchTableProps) => {
  const columns = ['Nº Lote', 'Validade', `Quantidade (${measureUnit})`, 'Remover']

  return (
    <S.ContainerRows>
      <S.Row style={{
        position: 'sticky', top: 0, background: '#EFEFEF', zIndex: 1,
      }}
      >
        {columns.map((column, index) => (
          <S.Column key={index}>
            <Typography sx={{ fontWeight: 'bold' }}>{column}</Typography>
          </S.Column>
        ))}
      </S.Row>
      {batches.filter((batch) => !batch.remove).length > 0
        ? batches.map((batch, index) => !batch.remove && (
          <S.Row
            key={`${index}${batch.batchNumber || '-'}${batch.dueDate}${batch.quantity}`}
            data-testid='receive-batch-table-row-test-id'
          >
            <S.Column>
              <Typography>{batch.batchNumber || '-'}</Typography>
            </S.Column>
            <S.Column>
              <Typography>{formatDateReplaceHour(new Date(batch.dueDate))}</Typography>
            </S.Column>
            <S.Column>
              <Typography>{batch.quantity}</Typography>
            </S.Column>
            <S.Column>
              <IconButton
                style={{
                  color: 'red',
                  cursor: 'pointer',
                }}
                onClick={() => removeBatch(index)}
                disabled={disableActions}
                data-testid='receive-batch-table-remove-button-test-id'
              >
                <DeleteOutline />
              </IconButton>
            </S.Column>
          </S.Row>
        )) : (
          <S.Row>
            <S.Column style={{ width: '100%', justifyContent: 'center' }}>
              <Typography>Nenhum lote adicionado</Typography>
            </S.Column>
          </S.Row>
        )}
    </S.ContainerRows>
  )
}
